import React, { useEffect, useContext } from "react";
import HeroSection from "../../components/sections/HeroSection";
import FeaturesSection from "../../components/sections/FeaturesSection";
import CtaSection from "../../components/sections/CtaSection";
import CardsSection from "../../components/sections/CardsSection";
import { ConnectionStatusContext } from "../../provider/ConnectionStatusProvider";

const HomePage: React.FC = () => {
  const connectionStatus = useContext(ConnectionStatusContext);
  const isLoggedIn = () => {
    const localStorageItem: any = localStorage.getItem("auth-item");
    if (localStorageItem) {
      const item = JSON.parse(localStorageItem);
      connectionStatus?.setAccounts(item?.accounts);
      connectionStatus?.setBalance(item?.balance);
      connectionStatus?.setType(item?.type);
      connectionStatus?.setLoading(false);
    } else {
      connectionStatus?.setLoading(false);
    }

    // console.log("localStorageItem", JSON.parse(localStorageItem));
  };

  useEffect(() => {
    isLoggedIn();
  }, []);
  return (
    <main>
      <HeroSection />
      <CardsSection />
      <FeaturesSection />
      <CtaSection />
    </main>
  );
};

export default HomePage;
